"use client";

import { isSchoolPath, schoolHref } from "@/lib/school-routes";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { type ComponentProps, forwardRef } from "react";

const SchoolLink = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof NextLink> & { schoolDestination?: string }
>(function SchoolLink({ href, schoolDestination, ...props }, ref) {
  const pathname = usePathname();
  if (schoolDestination && isSchoolPath(pathname)) href = schoolDestination;
  const resolvedHref =
    typeof href === "string"
      ? schoolHref(href, pathname)
      : href.host || href.hostname || href.protocol
        ? href
        : { ...href, pathname: schoolHref(href.pathname || "/", pathname) };
  return <NextLink ref={ref} href={resolvedHref} {...props} />;
});

export default SchoolLink;
